import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFieldAccessPins, pinsMatch } from "../utils/fieldAccessConfig";
import CommandPage from "./app/CommandPage";

export default function CommandLoginPage() {
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  useEffect(() => {
    const session = sessionStorage.getItem("fieldAccessCommand");
    if (session === "true") setUnlocked(true);
  }, []);

  async function handleLogin() {
    setError("");

    try {
      const config = await getFieldAccessPins();

      if (!pinsMatch(pin, config.commandPin)) {
        setError("Invalid PIN");
        return;
      }

      sessionStorage.setItem("fieldAccessCommand", "true");
      sessionStorage.setItem("fieldAccessHQ", "true");
      sessionStorage.setItem("fieldAccessDispatch", "true");
      sessionStorage.setItem("fieldAccessStatusBoard", "true");
      sessionStorage.setItem("fieldAccessSource", "command");

      setUnlocked(true);
    } catch (err) {
      console.error("Command PIN error:", err);
      setError("Unable to load PIN configuration");
    }
  }

  function handleLock() {
    sessionStorage.removeItem("fieldAccessCommand");
    sessionStorage.removeItem("fieldAccessHQ");
    sessionStorage.removeItem("fieldAccessDispatch");
    sessionStorage.removeItem("fieldAccessStatusBoard");
    sessionStorage.removeItem("fieldAccessSource");
    setUnlocked(false);
    setPin("");
  }

  if (!unlocked) {
    return (
      <div style={styles.center}>
        <div style={styles.card}>
          <button onClick={() => navigate("/field-access")} style={styles.backBtn}>
            ← Back
          </button>

          <h2>Command Access</h2>

          <input
            type="password"
            placeholder="Enter PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleLogin();
            }}
            style={styles.input}
          />

          <button onClick={handleLogin} style={styles.button}>
            Enter
          </button>

          {!!error && <div style={styles.error}>{error}</div>}
        </div>
      </div>
    );
  }

  return <CommandPage fieldMode onLock={handleLock} />;
}

const styles = {
  center: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8fafc",
  },
  card: {
    background: "#fff",
    padding: 24,
    borderRadius: 12,
    width: 320,
  },
  input: {
    width: "100%",
    padding: 12,
    marginBottom: 12,
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: 12,
    background: "#0f766e",
    color: "#fff",
    border: "none",
    borderRadius: 8,
  },
  backBtn: {
    background: "transparent",
    border: "1px solid #cbd5e1",
    padding: "6px 10px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 700,
    marginBottom: 10,
  },
  error: {
    color: "red",
    marginTop: 10,
  },
};